//hàm conver sang domain ảnh mới
export const convertImageDomain = (src: string): string => {
  if (
    typeof src === "string" &&
    src.startsWith("https://hanoicomputercdn.com")
  ) {
    return src.replace(
      "https://hanoicomputercdn.com",
      "https://cdn-files.hacom.vn/hacom/cdn/web"
    );
  }
  return src;
};
